@if (isOpen) {
<div class="custom-drawer-backdrop" (click)="onCancel()"></div>

<aside class="custom-drawer-panel" [class.open]="isOpen">
  <!-- Header -->
  <div class="drawer-header">
    <div class="header-titles">
      <h3 class="drawer-title">Column Configuration</h3>
      <p class="drawer-subtitle">Personalise and organise your HROPAL interface</p>
    </div>
    <button type="button" class="close-btn" (click)="onCancel()" title="Close">
      <i class="hgi hgi-stroke hgi-rounded hgi-cancel-01"></i>
    </button>
  </div>

  <!-- Tab Navigation -->
  <div class="tab-switcher-wrapper">
    <div class="tab-switcher-pill">
      <button
        type="button"
        class="tab-btn"
        [class.active]="activeTab === 'home'"
        (click)="setActiveTab('home')"
      >
        Home
      </button>
      <button
        type="button"
        class="tab-btn"
        [class.active]="activeTab === 'sections'"
        (click)="setActiveTab('sections')"
      >
        Sections
      </button>
    </div>
  </div>

  <!-- Drawer Body Content -->
  <div class="drawer-body-content">
    <!-- SECTIONS TAB -->
    @if (activeTab === 'sections') {
    <div class="tab-pane sections-pane">
      <div class="add-new-bar">
        <button type="button" class="add-new-btn" (click)="openNewSectionModal()">
          <i class="hgi hgi-stroke hgi-rounded hgi-add-01 me-1"></i>
          Add New
        </button>
      </div>

      <div class="config-list">
        @for (sec of config.sections; track sec.id; let idx = $index) {
        <div
          class="config-item-row"
          draggable="true"
          (dragstart)="onSectionDragStart(idx, $event)"
          (dragover)="onSectionDragOver($event)"
          (drop)="onSectionDrop(idx, $event)"
        >
          <div class="row-left">
            <span class="drag-handle" title="Drag to reorder">
              <i class="hgi hgi-stroke hgi-rounded hgi-menu-01"></i>
            </span>
            <span class="item-label">{{ sec.name }}</span>
          </div>

          <div class="row-right">
            <label class="toggle-switch">
              <input
                type="checkbox"
                [checked]="sec.enabled"
                (change)="toggleSection(sec)"
              />
              <span class="slider"></span>
            </label>
          </div>
        </div>
        }

        @if (config.sections.length === 0) {
        <div class="empty-state text-center py-4">
          <p class="text-muted fs-13 mb-0">No sections added yet. Click <strong>+ Add New</strong> above to create a section.</p>
        </div>
        }
      </div>
    </div>
    }

    <!-- HOME TAB -->
    @if (activeTab === 'home') {
    <div class="tab-pane home-pane">
      @for (sec of config.sections; track sec.id) {
        @if (sec.enabled) {
        <div class="home-section-group">
          <h4 class="section-group-title">{{ sec.name }}</h4>

          <div class="config-list">
            @for (item of sec.items; track item.id; let itemIdx = $index) {
            <div
              class="config-item-row"
              draggable="true"
              (dragstart)="onItemDragStart(sec.id, itemIdx, $event)"
              (dragover)="onItemDragOver($event)"
              (drop)="onItemDrop(sec.id, itemIdx, $event)"
            >
              <div class="row-left">
                <span class="drag-handle" title="Drag to reorder">
                  <i class="hgi hgi-stroke hgi-rounded hgi-menu-01"></i>
                </span>
                <span class="item-label">{{ item.name }}</span>
              </div>

              <div class="row-right">
                <label class="toggle-switch">
                  <input
                    type="checkbox"
                    [checked]="item.enabled"
                    (change)="toggleItem(item)"
                  />
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            }
          </div>

          <div class="add-new-bar mt-2 mb-3">
            <button
              type="button"
              class="add-new-btn"
              (click)="openNewFieldModal(sec.id)"
            >
              <i class="hgi hgi-stroke hgi-rounded hgi-add-01 me-1"></i>
              Add New
            </button>
          </div>
        </div>
        }
      }

      @if (config.sections.length === 0) {
      <div class="empty-state-box">
        <div class="empty-state-icon">
          <i class="hgi hgi-stroke hgi-rounded hgi-folder-add"></i>
        </div>
        <p class="empty-state-title">No sections created yet</p>
        <p class="empty-state-desc">Create your first section to start adding customized quick links to your sidebar.</p>
        <button type="button" class="btn-create-section" (click)="setActiveTab('sections')">
          <i class="hgi hgi-stroke hgi-rounded hgi-add-01 me-1"></i>
          Go to Sections & Add New
        </button>
      </div>
      }
    </div>
    }


  </div>

  <!-- Footer -->
  <div class="drawer-footer">
    <button
      type="button"
      class="btn-reset"
      (click)="onReset()"
      [disabled]="isSaving || isResetting"
      title="Reset sidebar to system default"
    >
      @if (isResetting) { Resetting... } @else { Reset to Default }
    </button>
    <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="isSaving || isResetting">Cancel</button>
    <button type="button" class="btn-save" (click)="onSave()" [disabled]="isSaving || isResetting">
      @if (isSaving) { Saving... } @else { Save }
    </button>
  </div>

  <!-- INNER POPUP: NEW SECTION MODAL -->
  @if (showNewSectionModal) {
  <div class="inner-modal-overlay">
    <div class="inner-modal-card">
      <h4 class="inner-modal-title">New Section</h4>

      <div class="form-group my-3">
        <label class="form-label">
          Name <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control custom-input"
          placeholder="Enter section name"
          [(ngModel)]="newSectionName"
          (keyup.enter)="addSection()"
          autofocus
        />
      </div>

      <div class="inner-modal-actions">
        <button type="button" class="btn-secondary-sm" (click)="closeNewSectionModal()">
          Cancel
        </button>
        <button
          type="button"
          class="btn-primary-sm"
          [disabled]="!newSectionName.trim()"
          (click)="addSection()"
        >
          Add
        </button>
      </div>
    </div>
  </div>
  }

  <!-- INNER POPUP: NEW FIELD MODAL -->
  @if (showNewFieldModal) {
  <div class="inner-modal-overlay">
    <div class="inner-modal-card">
      <h4 class="inner-modal-title">New Field</h4>

      <div class="form-group my-3">
        <label class="form-label">
          Field <span class="text-danger">*</span>
        </label>
        <app-dropdown
          [placeholder]="'Select'"
          [options]="availableSystemMenus"
          [bindLabel]="'displayName'"
          [bindValue]="'id'"
          [searchable]="true"
          [(ngModel)]="selectedFieldId"
        ></app-dropdown>
      </div>

      <div class="inner-modal-actions">
        <button type="button" class="btn-secondary-sm" (click)="closeNewFieldModal()">
          Cancel
        </button>
        <button
          type="button"
          class="btn-primary-sm"
          [disabled]="!selectedFieldId"
          (click)="addField()"
        >
          Add
        </button>
      </div>
    </div>
  </div>
  }
</aside>
}
